import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements, modifiers } from '../styles.js'
import { handle } from './wrapper.js'

const handler = (select, wrapper) => {
  const icon = one(`.${elements.icon}`, wrapper)
  let propertyValue = select.value

  if (propertyValue === '') {
    propertyValue = 'transparent'
  }

  icon.style.setProperty('--ea_icon_fill', `${propertyValue}`)
  select.style.setProperty('--ea_pattern_color_color', `${propertyValue}`)

  if (wrapper.classList.contains(modifiers.new_fieldset_pattern.new_pattern_color)) {
    const inputColor = one(`.${elements.new_field_input}`, wrapper)
    inputColor.value = select.value
  }
}

export default select => {
  handle(select, handler)
}